// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M7.5 2.71717L2 5.9255V21.4999L7.5 19.2326V2.71717Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M9.5 18.9095L14.5 21.8623V5.09027L9.5 2.13745V18.9095Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M16.5 4.76719V21.2826L22 18.0742V2.49987L16.5 4.76719Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-map-filled')
export default class MapFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'map-filled',
    }
  }
}
